import BaseService from "services/baseService";
import FetchService from "services/fetchService";
import modules from "mock/data.json";
import mockModuleStatus from "mock/moduleStatus.json";

export enum ModuleStatuses {
  "IN_PROGRESS" = "IN_PROGRESS",
  "COMPLETED" = "COMPLETED",
}
export enum ActivityStatuses {
  "IN_PROGRESS" = "IN_PROGRESS",
  "COMPLETED" = "COMPLETED",
}
export type ModuleActivity = {
  activityId: string;
  sequence: number;
  name: string;
  description: string;
};

export type ModuleSkill = {
  skillId: string;
  activities?: string[];
  subSkillIds?: string[];
};

export type Module = {
  type?: string;
  id: string;
  name: string;
  status?: any;
  shortDescription: string;
  launchURL: string;
  assessmentUrl?:string;
  duration: number;
  requiresVideo: boolean;
  requiresAudio: boolean;
  sequence: number;
  skills: ModuleSkill[];
  activities?: ModuleActivity[];
  imageUrl: string;
  insightsURL: string;
};

export type GetModulesResponse = {
  awsRequestId: string;
  userId: string;
  data: Module[];
};
class AssessmentService extends BaseService {
  servicePath = "assessment-modules";

  getModules(userId: string, sub?: string) {
    // return modules["data"] as Module[];
    return FetchService.get<GetModulesResponse["data"]>({
      url: this.getUrl(),
      data: { userId, sub },
      needAuth: true,
    });
  }

  // getStatus(userId: string, sub?: string) {
  //   // return mockModuleStatus["data"]["data"] as any[];
  //   return FetchService.get<any>({
  //     url: this.getUrl("status"),
  //     data: { userId, sub },
  //   });
  // }

  // async getModulesWithStatus(userId: string, sub: string) {
  //   let modules = await this.getModules(userId, sub);
  //   console.log("Modules Response: ", modules);
  //   let statuses: any = await this.getStatus(userId, sub);
  //   let statusesArr = statuses || [];

  //   let statusMap: Map<string, any> = new Map();
  //   for (let i = 0; i < statusesArr.length; i++) {
  //     const element = statusesArr[i];
  //     statusMap.set(element.id, element);
  //     statusMap.set("type","assess")
  //   }

  //   (modules || []).map((module: any) => {
  //     let key;
  //     if (statusMap.has(module.id)) {
  //       key = module.id;
  //     } 
  //     if (key) {
  //       module.status = statusMap.get(key);
  //       module.type = statusMap.get("type")
  //       statusMap.delete(key);
  //     }
  //     module.type = "assess"
  //   });
  //   return modules;
  // }

  async getEdgeModules(userId: string, sub?: string): Promise<Module[]> {
    try {
      const response = await FetchService.get<GetModulesResponse["data"]>({
        url: this.getUrl("edge"),
        data: { userId, sub },
        needAuth: true,
      });
      return response ?? [];
    } catch (error) {
      console.error("Failed to fetch edge modules:", error);
      return [];
    }
  }  

  async getEdgeModuleStatus(userId: string, sub?: string): Promise<Module[]> {
    try {
      const responseStatus = await FetchService.get<GetModulesResponse["data"]>({
        url: this.getUrl("edge/status"),
        data: { userId, sub },
        needAuth: true,
      });
  
      return responseStatus;
    } catch (error: any) {
      console.error("Error fetching edge module status:", error);
      return [];
    }
  }
  
  async getEdgeModulesWithStatus(userId: string, sub: string) {
    let modules = await this.getEdgeModules(userId, sub);
    let statuses: any = await this.getEdgeModuleStatus(userId, sub);
    let statusesArr = statuses || [];

    let statusMap: Map<string, any> = new Map();
    for (let i = 0; i < statusesArr.length; i++) {
      const element = statusesArr[i];
      statusMap.set(element.id, element);
      statusMap.set("type","edge")
    }

    (modules || []).map((module: any) => {
      let key;
      if (statusMap.has(module.assessmentId)) {
        key = module.assessmentId;
      } 
      if (key) {
        module.status = statusMap.get(key);
        statusMap.delete(key);
      }
      module.type = "edge"
    });
    return modules;
  }

   getApprizeModules =(userId: string, sub?: string)=>{
    return FetchService.get<GetModulesResponse["data"]>({
      url: this.getUrl("apprize"),
      data: { userId, sub },
      needAuth: true,
    });
  }
  
  getApprizeStatus = (userId: string, sub: string)=>{
    return FetchService.get<GetModulesResponse["data"]>({
      url: this.getUrl("apprize/status"),
      data: { userId, sub },
      needAuth: true,
    });
  }

  getApprizeModulesWithStatus = async (userId: string, sub: string) => {
    let apprize: any[] = [];
    let status: any[] = [];
  
    try {
      apprize = await this.getApprizeModules(userId, sub);
    } catch (error) {
      console.error("Error fetching Apprize modules:", error);
    }
  
    try {
      status = await this.getApprizeStatus(userId, sub);
    } catch (error) {
      console.error("Error fetching Apprize status:", error);
    }
  
    const statusesArr = status || [];
    const statusMap: Map<string, any> = new Map();
  
    for (const element of statusesArr) {
      statusMap.set(element.id, element);
    }
  
    for (const module of apprize || []) {
      if (statusMap.has(module.id)) {
        module.status = statusMap.get(module.id);
        statusMap.delete(module.id);
      }
      module.type = "apprize"
    }
  
    return apprize;
  };

}

const assessmentService = new AssessmentService();
export default assessmentService;
